// extracted by mini-css-extract-plugin
export default {"hsScoreButtons":"ScoreButtons_hsScoreButtons__359Oa"};